import React from 'react';

const Footer = () => {
  return (
  <><div className='wave'></div>
   <div className="footer">  <div className="box footer-gallery">
     
     <img className="logo-img" src="imgs/Mohamed abi.png" alt="" />
   </div>
 <div className="container">
 
   <div className="box">
     <h3>MED ABI DEV WEB</h3>
     <ul className="social">
       <li>
         <a href="https://www.facebook.com/abi.mohamed.10" target="_blank" rel="noopener noreferrer" className="facebook">
           <i className="fab fa-facebook-f"></i>
         </a>
       </li>
       <li>
         <a href="https://twitter.com/mohamed52568273" target="_blank" rel="noopener noreferrer" className="twitter">
           <i className="fab fa-twitter"></i>
         </a>
       </li>
       <li>
         <a href="https://www.youtube.com/@mohamedabi6415/channels" target="_blank" rel="noopener noreferrer" className="youtube">
           <i className="fab fa-youtube"></i>
         </a>
       </li>
       <li>
         <a href="https://github.com/mohamedabi17" target="_blank" rel="noopener noreferrer" className="github">
           <i className="fa fa-github"></i>
         </a>
       </li>
     </ul>
     <p className="text">
       In case You are looking for a software engineer who can solve your problems with little bit of Magic  Tech 
     </p>
   </div>
   <div className="box">
     <ul className="links">
       <li><a href="#">Important Link 1</a></li>
       <li><a href="#">Important Link 2</a></li>
       <li><a href="#">Important Link 3</a></li>
       <li><a href="#">Important Link 4</a></li>
       <li><a href="#">Important Link 5</a></li>
     </ul>
   </div>
   <div className="box">
     <div className="line">
       <i className="fas fa-map-marker-alt fa-fw"></i>
       <div className="info">Les Eucalyptus, Alger</div>
     </div>
     <div className="line">
       <i className="far fa-clock fa-fw"></i>
       <div className="info">Business Hours: Flexible</div>
     </div>
     <div className="line">
       <i className="fas fa-phone-volume fa-fw"></i>
       <div className="info">
         <span>+213774852508</span>
         <span>+213774852508</span>
       </div>
     </div>
   </div>
   
 </div>
 <p className="copyright">
   Made With
   <span className="material-symbols-outlined">
     volunteer_activism
   </span>
   By MOHAMED ABI
 </p>
</div>
  
  </>
   
  );
};

export default Footer;
